module.exports = __webpack_public_path__ + "media/images/athletes/1570-d2d89c0cb2bf214648dadc2cefe3dad3.png";